<script>
import _debounce from "lodash/debounce";
import pagination from "@/mixins/pagination";
import tableSearch from "@/mixins/tableSearch";
import CommonTableComponent from "@/components/table.vue";
import apiEndpoints from "@/services/apiEndpoints";
import estimate from "@/state/modules/estimate";

export default {
  components: {
    CommonTableComponent
  },
  props: ["car_types_by_work_order", "disabled"],
  mixins: [pagination, tableSearch],
  data() {
    return {
      isLoading: false,
      estimates: [],
      dataSelected: [],
      visible: false,
      filters: {
        column: "estimates.estimate_cd",
        dir: "ASC",
      }
    };
  },
  methods: {
    async getData() {
      this.isLoading = true;
      const url = apiEndpoints.projects_sales_estimates_vehicles_list(this.$route.params.id);
      const sendApiEstimateWithVehicles = await this.$http.get(url, this.filters);
      const { status, data } = sendApiEstimateWithVehicles;

      if (status && data.result.length > 0) {
        this.estimates = data.result;
        this.estimates = this.estimates.map(estimate => ({
          ...estimate,
          number_of_cars:
            this.car_types_by_work_order.find(
              car_types_by_work_order => car_types_by_work_order.estimate_id == estimate.id
            )?.number_of_cars ?? null
        }));
      } else {
        this.estimates = [];
      }
      this.isLoading = false;
    },
    updateValue: function() {
      let car_types_by_work_order = this.estimates
        .filter(item => item.number_of_cars && item.number_of_cars > 0)
        .map(item => ({
          estimate_id: item.id,
          estimate_cd: item.estimate_cd,
          number_of_cars: item.number_of_cars,
          invoice_product_name: item.invoice_product_name,
        }));

      this.$emit("dataSelected", car_types_by_work_order);
      this.$bvModal.hide("select-vehicles");
    },
    clickSort (column) {
      if (column !== this.filters.column) {
        this.filters.column = column;
        this.filters.dir = 'DESC';
        this.updateUrlFilters();
        return;
      }

      this.filters.dir = (this.filters.dir === 'ASC') ? 'DESC' : 'ASC';
      this.updateUrlFilters();
    },
    updateUrlFilters () {
      // sort data in client, not in server
      const currentEstimates = [...this.estimates];
      const column = this.filters.column.replace('estimates.', '').toLowerCase();
      const dir = this.filters.dir.toLowerCase();
      this.estimates = this.$_.orderBy(currentEstimates, [column], [dir]);
    },
    formatterPositiveNumber(value){
      return Math.abs(value)
    }
  },
  computed: {
    headers() {
      return [
        {
          text: "見積明細番号",
          value: "estimates.estimate_cd",
          sortable: true
        },
        {
          text: "サービス名",
          value: "services.name",
          sortable: true
        },
        {
          text: "請求書表示用商品名",
          value: "invoice_product_name",
          sortable: true
        },
        {
          text: "単価",
          value: "unit_price",
          sortable: true
        },
        {
          text: "台数",
          value: "number_of_cars",
          sortable: true
        }
      ];
    },
    selectedAll: {
      get() {
        return this.estimates
          ? this.dataSelected.length == this.estimates.length
          : false;
      },
      set(value) {
        if (value) {
          this.dataSelected = this.estimates.map(
            estimate => estimate.id
          );
        } else {
          this.dataSelected = [];
        }
      }
    }
  },
  watch: {
    car_types_by_work_order: {
      handler: function(val) {
        if (!val || !val.length) return;
        this.dataSelected = val.map(item => item.estimate_id);
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
<template>
  <div class="mb-2 d-xl-flex">
    <button
      v-b-modal.select-vehicles
      class="btn btn-primary waves-effect waves-light"
      :disabled="disabled"
    >
      <i class='far fa-list-alt'></i> 車両を選択する
    </button>
    <!-- modal area -->
    <b-modal
      size="lg"
      id="select-vehicles"
      centered
      title-class="font-18"
      hide-footer
      title="車両一覧"
      scrollable
      @show="getData"
      @hidden="$emit('modalHidden', 'key_cars')"
    >
      <b-row class="mt-2">
        <b-overlay
          :show="isLoading"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block"
        >
          <div class="vehicles">
            <CommonTableComponent
              :height-class="`table-wrapper-500`"
              :scrollAble="
                estimates.length >= this.$constant.scroll_able_records
              "
            >
              <thead class="table-light">
                <tr>
                  <th
                    v-for="(item, index) in headers"
                    :key="index"
                    :class="getHeaderClass(item)"
                  >
                <span v-if="item.sortable" @click="clickSort(item.value)">
                  {{ item.text }}
                  <i :class="getSortClass(item.value)"></i>
                </span>
                    <span v-else>
                  {{ item.text }}
                </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in estimates" :key="index">
                  <td class="text-left">{{ item.estimate_cd }}</td>
                  <td>{{ item.name }}</td>
                  <td>
                    {{ item.invoice_product_name || "" }}
                  </td>
                  <td class="text-right">{{item.unit_price}}</td>
                  <td>
                    <b-form-input
                      :formatter="formatterPositiveNumber"
                      min="0"
                      class="w-50 min-width-num"
                      :id="`vehicle_${item.id}`"
                      type="number"
                      v-model="item.number_of_cars"
                    ></b-form-input>
                  </td>
                </tr>
                <tr v-if="!estimates.length && !isLoading">
                  <td :colspan="headers.length + 1" class="text-center">
                    データなし。
                  </td>
                </tr>
              </tbody>
            </CommonTableComponent>
          </div>
          <div class="d-flex justify-content-end mt-2">
            <button
              @click="updateValue"
              class="btn btn-primary w-md waves-effect waves-light"
            >
              <i class='fas fa-check'></i> 確定
            </button>
          </div>
        </b-overlay>
      </b-row>
    </b-modal>
  </div>
</template>
<style lang="scss">
.text-right {
  text-align: right;
}
.min-width-num{
  min-width: 75px;
}
</style>